import React, { useCallback, useState } from "react";
import { Button } from "reactstrap";
import ExportLoadingModal from "Components/Common/ExportLoadingModal";
import Permission from "Components/Common/Permission";
import { toast } from "react-toastify";

type AgencyExportButtonProps = {
  action?: string;
  className?: string;
  color?: string;
  controller?: string;
  exportCsv: (params: any) => Promise<any>;
  filename: string;
  label?: string;
  params?: any;
  resource: string;
  toastLabel: string;
};

export const downloadCsvBlob = (response: any, filename: string) => {
  const url = window.URL.createObjectURL(new Blob([response]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const AgencyExportButton = ({
  action = "exportToCsv",
  className,
  color = "primary",
  controller,
  exportCsv,
  filename,
  label = "Export",
  params,
  resource,
  toastLabel,
}: AgencyExportButtonProps) => {
  const [exporting, setExporting] = useState(false);

  const handleExport = useCallback(async () => {
    try {
      setExporting(true);
      const response = await exportCsv({
        filters: params?.filters,
        sort: params?.sort,
      });
      downloadCsvBlob(response, filename);
    } catch (error) {
      toast.error(`An error occurred while exporting ${toastLabel}`);
    } finally {
      setExporting(false);
    }
  }, [exportCsv, filename, params?.filters, params?.sort, toastLabel]);

  return (
    <Permission resource={resource} controller={controller} action={action}>
      <Button
        color={color}
        className={`btn-label ${className || ""}`.trim()}
        disabled={exporting}
        onClick={handleExport}
      >
        <i className="ri-download-2-line label-icon align-middle fs-16 me-2"></i>
        {exporting ? "Exporting..." : label}
      </Button>
      <ExportLoadingModal show={exporting} onCloseClick={() => {}} />
    </Permission>
  );
};

export default AgencyExportButton;
